
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Document = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M14.7,2H4.5V23H16.4a4.2,4.2,0,0,0,4.1-4.1V8.4Zm.1,2.4L18,7.9H15.6a.9.9,0,0,1-.8-.8Zm1.6,17.1H6V3.5h7.3V7.1a2.3,2.3,0,0,0,2.3,2.3H19v9.5A2.6,2.6,0,0,1,16.4,21.5Z"></path>
        </g>
      </g>
    </IconBase>);
};

Document.defaultProps = {
  title: 'Document',
};

export default Document;
